module.exports = __webpack_public_path__ + "static/media/faisal.af61d955.png";